module.exports = __webpack_public_path__ + "static/img/zn_no.3.4365ca4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zn_no.3.jpg
// module id = oLeo
// module chunks = 17